var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-auto order-2 order-md-3 v-navbar-menu__wrapper"},[_c('ul',{staticClass:"v-navbar-menu d-flex d-print-none align-items-end"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }